<div class="__icon-container" [ngSwitch]="nuggetMode">
  <awair-noti-bell *ngSwitchCase="NuggetMode.NotificationSetting"
                   [hasNotification]="hasNotification">
  </awair-noti-bell>
  <awair-index-dot *ngSwitchDefault
                   style="padding-top: 2px;"
                   [color]="indexDotColor">
  </awair-index-dot>
</div>

<div class="__text-container">
  <h4 class="__header">{{deviceName}}</h4>

  <div class="__sub-text-container">
    <span class="__sub-text--bold">{{deviceType}}</span>
    <span class="__sub-text">
      {{(ownerFirstName.length < 1 && ownerLastName.length < 1) ? email : ownerFirstName + ' ' + ownerLastName}}
    </span>
  </div>
</div>
